import { ShoppingBag } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useCart } from "@/hooks/useCart";
import { useState, useEffect, useRef } from "react";
import { supabase } from "@/integrations/supabase/client";

interface CartIconProps {
  onClick: () => void;
}

export function CartIcon({ onClick }: CartIconProps) {
  const { itemCount, refreshCart } = useCart();
  const [hasActiveProducts, setHasActiveProducts] = useState(false);
  const hasCheckedProducts = useRef(false);

  // Check if there are any active products (only once)
  useEffect(() => {
    if (hasCheckedProducts.current) return;
    hasCheckedProducts.current = true;
    
    const checkActiveProducts = async () => {
      const { data, error } = await supabase
        .from("products")
        .select("id")
        .eq("is_active", true)
        .limit(1);

      if (!error && data && data.length > 0) {
        setHasActiveProducts(true);
      }
    };

    checkActiveProducts();
  }, []);

  // Only show if there are active products on the site
  if (!hasActiveProducts) return null;

  return (
    <div className="fixed top-4 right-4 z-50">
      <Button
        onClick={async () => {
          await refreshCart();
          onClick();
        }}
        size="icon"
        className="relative bg-primary hover:bg-primary/90 text-primary-foreground rounded-full w-14 h-14 shadow-lg"
        aria-label={`Panier${itemCount > 0 ? ` - ${itemCount} article${itemCount > 1 ? 's' : ''}` : ''}`}
      >
        <ShoppingBag className="w-6 h-6" aria-hidden="true" />
        {itemCount > 0 && (
          <Badge 
            className="absolute -top-2 -right-2 bg-secondary text-secondary-foreground"
            aria-hidden="true"
          >
            {itemCount}
          </Badge>
        )}
      </Button>
    </div>
  );
}
